import { Check, Square } from 'lucide-react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface FeatureCheckboxProps {
  id: string;
  title: string;
  description?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  'data-testid'?: string;
}

export const FeatureCheckbox: React.FC<FeatureCheckboxProps> = ({
  id,
  title,
  description,
  checked = false,
  onChange,
  disabled = false,
  className,
  'data-testid': dataTestId,
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      id={id}
      data-testid={dataTestId}
      onClick={handleClick}
      disabled={disabled}
      className={twMerge(
        'flex w-[310px] items-start gap-4 rounded-lg py-4 pr-2 pl-4 transition-colors duration-200',
        'border-chariot-stroke border-2',
        checked && 'border-chariot-brand-primary',
        disabled && 'cursor-not-allowed opacity-50',
        className
      )}
    >
      {/* Checkbox */}
      {checked && (
        <div
          className={twMerge(
            'relative size-5 shrink-0 rounded-md',
            'flex items-center justify-center',
            'chariot-brand-primary bg-chariot-brand-primary'
          )}
        >
          <Check className={'size-3 stroke-[3px] text-white'} />
        </div>
      )}

      {!checked && (
        <Square className="text-chariot-stroke size-5 shrink-0 stroke-[3px]" />
      )}

      {/* Text content */}
      <div className="text-left">
        <p className="text-chariot-text-primary text-sm font-semibold">
          {title}
        </p>
        {description && (
          <p className="text-chariot-text-primary mt-0.5 text-xs">
            {description}
          </p>
        )}
      </div>
    </button>
  );
};

export default FeatureCheckbox;
